import type podcast from "@/content/budget-2027-podcast.json";

/** Audio languages are independent of the website's EN/BM/ZH page locales. */
export type PodcastLanguage = keyof typeof podcast.episodes;

export const budgetPodcastPageUrl = "https://www.anchorsprint.com/guides/malaysia-budget-2027/";

export function getBudgetPodcastAudioUrl(language: PodcastLanguage): string {
  return `${budgetPodcastPageUrl}audio/debrief-${language}.mp3`;
}

export const podcastLanguageTags: Record<PodcastLanguage, string> = {
  en: "en-MY",
  ta: "ta-MY",
  ms: "ms-MY",
  zh: "zh-Hans-MY",
  yue: "yue-MY",
};

export const podcastLanguages = ["en", "ta", "ms", "zh", "yue"] as const satisfies readonly PodcastLanguage[];

export function isPodcastLanguage(value: string): value is PodcastLanguage {
  return podcastLanguages.some((language) => language === value);
}

export const podcastLanguageLabels: Record<PodcastLanguage, string> = {
  en: "English",
  ta: "தமிழ் · Tamil",
  ms: "Bahasa Melayu",
  zh: "中文（普通话）",
  yue: "廣東話 · Cantonese",
};

export const podcastSpeakerLabels: Record<PodcastLanguage, { host: string; analyst: string }> = {
  en: { host: "Host", analyst: "Analyst" },
  ta: { host: "தொகுப்பாளர்", analyst: "ஆய்வாளர்" },
  ms: { host: "Pengacara", analyst: "Penganalisis" },
  zh: { host: "主持人", analyst: "分析员" },
  yue: { host: "主持人", analyst: "分析員" },
};
